var _rect, _path, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditlibicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.01709,
    y: 0.875,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5586 8.7085H8.85026C8.34193 8.7085 7.85442 8.91043 7.49497 9.26987C7.13553 9.62932 6.93359 10.1168 6.93359 10.6252V24.0418C6.93359 24.5502 7.13553 25.0377 7.49497 25.3971C7.85442 25.7566 8.34193 25.9585 8.85026 25.9585H22.2669C22.7753 25.9585 23.2628 25.7566 23.6222 25.3971C23.9817 25.0377 24.1836 24.5502 24.1836 24.0418V17.3335",
    stroke: "#051C48",
    strokeWidth: 1.54867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7461 7.27073C23.1273 6.88948 23.6444 6.67529 24.1836 6.67529C24.7228 6.67529 25.2398 6.88948 25.6211 7.27073C26.0023 7.65197 26.2165 8.16906 26.2165 8.70823C26.2165 9.24739 26.0023 9.76448 25.6211 10.1457L16.5169 19.2499L12.6836 20.2082L13.6419 16.3749L22.7461 7.27073Z",
    stroke: "#051C48",
    strokeWidth: 1.54867,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.01709,
    y: 0.875,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#A5BBE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditlibicon);
export default __webpack_public_path__ + "static/media/editlibicon.6ec91da6486ea5f6fcb081abb7875b0d.svg";
export { ForwardRef as ReactComponent };